<template>
    <div>
    <HistogramWrapper
        :value="compValue"
        :size="size"
        :width="width"
        :height="height"
        :minCap="compMinCap"
        :maxCap="compMaxCap"
        :sliderData="compSliderData"
        @input="update"
        :expo="expo"
        :key="updateHisto" />
    </div>
</template>

<script>
import HistogramWrapper from './HistogramWrapper.vue';

export default {
    name: 'HistogramSliderW2',
    components: {
      HistogramWrapper
    },
    props: {
      sliderData:Array,
      value: {
        type: [Array, Object],
        default: () => [],
      },
      width: {
        type: Number,
        default: 180
      },
      height: {
        type: Number,
        default: 25
      },
      expo: {
        type: Boolean,
        default: false
      },
      size: {
        type: Number,
        default: 10
      }
    },
    data() {
      var arr = this.sliderData
      var min = arr[0]
      var max = arr[arr.length-1]
      return {
        minCap: min,
        maxCap: max,
        minMoved: false,
        maxMoved: false,
        updateHisto: 0,

        retVal: '',
      }
    },
    mounted(){
    },
    methods: {
      update(val) {
        this.minMoved = this.minCap < val[0]
        this.maxMoved = this.maxCap > val[1]
        this.$emit('input', val)
      }
    },
    computed: {
      compSliderData() {
        var data = this.sliderData
        if (this.expo) {
          data = this.sliderData.map(v => Math.log(v))
        }
        return data
      },
      compValue() {
        var val = this.value
        if (this.expo) {
          val = [Math.log(val[0]), Math.log(val[1])]
        }
        return val;
      },
      compMinCap() {
        var val = this.minCap
        if (this.expo) {
          val = Math.log(this.minCap)
        }
        return val
      },
      compMaxCap() {
        var val = this.maxCap
        if (this.expo) {
          val = Math.log(this.maxCap)
        }
        return val
      }
    },
    watch: {
      /*
      value: function (val, oldVal){
        var arr = this.sliderData
        var min = arr[0]
        var max = arr[arr.length-1]
        this.minCap = min
        this.maxCap = max
        if (this.minMoved && oldVal[0] > min && oldVal[0] < max) {
          this.value[0] = oldVal[0]
        }
        else {
          this.minMoved = false
        }
        if (this.maxMoved && oldVal[1] < max && oldVal[1] > min) {
          this.value[1] = oldVal[1]
        }
        else {
          this.maxMoved = false
        }

        this.updateHisto += 1;
      },
      */
      SliderData: function (val, oldVal) {
        this.updateHisto += 1;
      }
    }
}
</script>
